import React, {useEffect, useState} from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {useTranslation} from 'react-i18next';
import {makeStyles} from '@material-ui/core/styles';
import classnames from 'classnames';
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent/DialogContent";
import DialogActions from '@material-ui/core/DialogActions';
import {ActionButton} from 'components/common';
import PMCSnackbar from "../../common/Snackbar";
import RoleDetail from "./ExtRoleDetail";
import RoleTable from "./ExtRoleTable";
import {fetchAllUsersByRole} from "../../../redux/actions/extusers";
import {CustomSearchInput} from 'components/elements';
  
import Stepper from '@material-ui/core/Stepper';
import StepLabel from '@material-ui/core/StepLabel';
import Step from '@material-ui/core/Step';
import { isComponentVisibleForUser } from 'utils';


const useStyles = makeStyles((theme) => ({
    container: {
        '& .MuiDialog-paper': {
            maxHeight: 855,
            minHeight: '90%',
            maxWidth: 'unset',
            // boxShadow: theme.palette.shadow.main,
        },
        height: '100%',
        border: 'groove',
    },
    search: {
        paddingTop: '10px',
    },
    actions: {
        padding: 0,
    },
    title: {
        height: 96,
        background: theme.palette.secondary.main,

        '& h2': {
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            fontSize: 26,
            lineHeight: '30px',
            color: theme.palette.base.white,
        },
    },
    content: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        height: '100%',
        margin: 0,
        paddingBottom: theme.spacing(4),

    },
    button: {
        width: 180,
        height: 40,
        marginLeft: 20,
        marginRight: 20,
        fontSize: 14,
    },
    buttonNavigation: {
        display: 'flex',
        background: theme.palette.base.white,
        height: '55px',
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
        bottom: 0,
        width: '50%',
        justifyContent: 'flex-end',
    },
    buttonNavigationCancel: {
        display: 'flex',
        background: theme.palette.base.white,
        height: '55px',
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
        bottom: 0,
        width: '50%',
        justifyContent: 'left',
    },
    wrapper: {
        margin: theme.spacing(1),
        position: 'relative',
    },
    buttonProgress: {
        position: 'absolute',
        top: '50%',
        left: '50%',
    },
    
}));


function ExtRole(props) {
    const {
        userUseCases,
        useCases,
        handleClose,
        readOnly,
        roleConfigModel,
        mode,
        handleNext,
        handleBack,
        handleSearch,
        fetchAllUsersByRole,
        roleUsers,
        allUsers,
        searchMenuItemClick,
        handleRemoveUser,
    } = props;


    const classes = useStyles();

    const {t} = useTranslation();


    const [roleDetail, setRoleDetail] = useState();
    const [users, setUsers] = useState();
    const [isUsersSeted, setIsUsersSeted] = useState(false);
    const [errorStep1, setErrorStep1] = useState({});
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const [severity, setSeverity] = useState('error');
    const [isFetchedRoleUser, setIsFetchedRoleUser] = useState();
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        if (!isFetchedRoleUser && roleDetail && roleDetail.roleExtId) {
            setIsLoading(true);
            fetchAllUsersByRole(roleDetail.roleExtId).then(() => {
                setIsFetchedRoleUser(true);
                setIsLoading(true);
            }).catch((err) => {
                setIsFetchedRoleUser(false);
                setIsLoading(false)
            });
        }
    }, [isFetchedRoleUser, fetchAllUsersByRole, roleDetail]);

    useEffect(() => {
        if (roleConfigModel.role) {
            setRoleDetail(roleConfigModel.role);
            setIsFetchedRoleUser(false);
        }
        setErrorStep1({});
        setSeverity("error");
        setSnackbarOpen(false);
        setSnackbarMessage('');
    }, [roleConfigModel]);

    useEffect(() => {
        if ( allUsers ) {
            let tmp = allUsers.filter((item) => {
                for ( let i=0; i<roleUsers.length; i++ ) {
                    if ( roleUsers[i].userExtId===item.userExtId )
                        return false;
                }
                return true;
            });

            setUsers(tmp);
            setIsUsersSeted(true);
        }
    }, [allUsers, isUsersSeted])

    const handleCloseSnackbar = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setSnackbarOpen(false);
    };

    const getSteps = () => {
        return [t('BASIC_INFORMATION'), t('ASSINGED_USERS')];
    }

    const [activeStep, setActiveStep] = useState(0);
    const steps = getSteps();

    const handleNextLocal = () => {
        setActiveStep((activeStep) => activeStep + 1);
        handleNext();
    };

    const handleBackLocal = () => {
        setActiveStep((activeStep) => activeStep - 1);
        handleBack();
    };

    const searchMenuItemClickLocal = (userId) => {
        searchMenuItemClick(userId, roleDetail.roleExtId);
        setIsFetchedRoleUser(false);
        setIsUsersSeted(false);
    }
    
    const handleRemoveUserLocal = (user) => {
        handleRemoveUser(user.userExtId, roleDetail.roleExtId);
        setIsFetchedRoleUser(false);
        setIsUsersSeted(false);
    }
    
    const searchMenuData = users && users.length > 0
    ? users.map((data) => ({
        key: data.userExtId,
        label: data.userName,
        value: data.userExtId,
        }))
    : [];

    return (
        <Dialog
            className={classes.container}
            open={roleConfigModel.open}
            onClose={handleClose}
        >
            <DialogTitle className={classnames(classes.title)}>
                <span>
                    {t('EXT_ROLE_DETAIL')}
                </span>
            </DialogTitle>

            <PMCSnackbar open={snackbarOpen} onClose={handleCloseSnackbar} severity={severity} message={snackbarMessage}/>

            <Stepper activeStep={activeStep} color="secondary" >
                {steps.map((label, index) => {
                    const stepProps = {};
                    const labelProps = {};
                    return (
                        <Step key={label} {...stepProps}>
                            <StepLabel {...labelProps}>{label}</StepLabel>
                        </Step>
                    );
                })}
            </Stepper>

            {mode===STEP_ONE &&
                <>
                <DialogContent className={classes.content}>
                    <div className={classes.container}>
                        <RoleDetail 
                            userUseCases={userUseCases}
                            useCases={useCases}
                            updatedRole={roleDetail}
                            error={errorStep1}
                            readOnly={readOnly}
                            setSnackbarError={setSnackbarMessage}
                            setSnackbarOpen={setSnackbarOpen}
                        />
                    </div>
                </DialogContent>
                <DialogActions className={classes.actions}>
                    <div className={classes.buttonNavigationCancel}>
                        <div className={classes.wrapper}>

                            <ActionButton
                                action="close"
                                handleClick={handleClose}
                                className={classes.button}
                            />
                        </div>

                    </div>
                    <div className={classes.buttonNavigation}>
                        <div className={classes.wrapper}>
                            <ActionButton
                                action="back"
                                handleClick={handleBackLocal}
                                className={classes.button}
                                disabled={true}
                            />
                        </div>
                        <div className={classes.wrapper}>
                            <ActionButton
                                action="next"
                                handleClick={handleNextLocal}
                                className={classes.button}
                            />
                        </div>
                    </div>
                </DialogActions>
                </>
            }
            {mode===STEP_TWO &&
                <>
                <DialogContent className={classes.content}>
                    <div className={classes.container}>
                        <div className={classes.search}>
                            <CustomSearchInput
                                placeholder={t('USER_NAME')}
                                menuData={searchMenuData}
                                menuItemClick={searchMenuItemClickLocal}
                                handleChange={handleSearch}
                                disabled={!isComponentVisibleForUser(UC_EXT_USER_UPDATE, userUseCases)}
                            />
                        </div>

                        <RoleTable 
                            userUseCases={userUseCases}
                            useCases={useCases}
                            updatedRole={roleDetail}
                            roleUsers={roleUsers}
                            error={errorStep1}
                            readOnly={readOnly}
                            setSnackbarError={setSnackbarMessage}
                            setSnackbarOpen={setSnackbarOpen}
                            handleRemoveUser={handleRemoveUserLocal}
                        />
                    </div>
                </DialogContent>
                <DialogActions className={classes.actions}>
                    <div className={classes.buttonNavigationCancel}>
                        <div className={classes.wrapper}>

                            <ActionButton
                                action="close"
                                handleClick={handleClose}
                                className={classes.button}
                            />
                        </div>
                    </div>
                    <div className={classes.buttonNavigation}>
                        <div className={classes.wrapper}>
                            <ActionButton
                                action="back"
                                handleClick={handleBackLocal}
                                className={classes.button}
                            />
                        </div>
                        <div className={classes.wrapper}>
                                <ActionButton
                                    action="next"
                                    handleClick={handleNextLocal}
                                    className={classes.button}
                                    disabled={true}
                                />
                        </div>
                    </div>
                </DialogActions>
                </>
            }
        </Dialog>

    );
}

const STEP_ONE = 'STEP_1';
const STEP_TWO = 'STEP_2';
const UC_EXT_USER_UPDATE = 'UC0695';

ExtRole.propTypes = {};

const mapStateToProps = (store) => ({
    roleUsers: store.extUsersData.roleUsers,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchAllUsersByRole,
}, dispatch);

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(ExtRole);


